// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-header[data-v-cf6573c0] {\n  font-size: 18px;\n}\n.sub-header[data-v-cf6573c0]:not(:first-child) {\n  margin-top: 50px;\n}\n#message[data-v-cf6573c0] {\n  height: 150px;\n}\n@media only screen and (min-width: 768px) {\n.contact-form[data-v-cf6573c0] {\n    margin-left: 50px;\n}\n}", ""]);
// Exports
module.exports = exports;
